module.exports = __webpack_public_path__ + "static/img/pete_pictgrid4_800x757.f2ab62c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pete_pictgrid4_800x757.jpg
// module id = bfC3
// module chunks = 0